import React from 'react';
import { css } from '@emotion/core';
import VerifyStatusLabel from 'client/components/verify/VerifyStatusLabel';
import { entryVerifyStatus } from 'config/entryVerifyStatus';

export default function ResultValidStatus({ validStatus }) {
    return validStatus !== entryVerifyStatus.PASSED ? (
        <div css={statusStyle}>
            <VerifyStatusLabel status={validStatus} />
        </div>
    ) : null;
}

const statusStyle = css`
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
`;
